import { Typography } from 'antd';
import phone from 'src/assets/phone_in_talk_black_24dp 1.png';
import email from 'src/assets/email_black_24dp 1.png';
import VisibilityFilter from '../components/visibilityFilter';
import { UserRole } from 'src/common/commonTypes';

function Footer() {
    return (
        <div className="footer">
            <div className="footer_content">
                <VisibilityFilter role={UserRole.AC}>
                    <div className="footer-item">
                        <Typography.Text>
                            <img src={email} alt="email-icon" />
                            <span>psp@sicmt.ru</span>
                        </Typography.Text>
                    </div>
                </VisibilityFilter>
                <VisibilityFilter exceptRole={UserRole.AC}>
                    <>
                        <div className="footer-item">
                            <Typography.Text>
                                <img src={phone} alt="phone-icon" />
                                <span>8 (495) 380-21-53</span>
                            </Typography.Text>
                        </div>
                        <div className="footer-item">
                            <Typography.Text>
                                <img src={email} alt="email-icon" />
                                <span>support@asutk.ru</span>
                            </Typography.Text>
                        </div>
                    </>
                </VisibilityFilter>
            </div>
        </div>
    );
}

export default Footer;
